import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useMutation } from 'react-query';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import * as htmlToImage from 'html-to-image';
import request from '@utils/request';
import { formatNumber, formatDateTime } from '@utils/helper';
import { makeSelectUserList, makeSelectUser } from '@/global.selectors';
import { Row, Col, Pagination, Spin, Button, Input, Select } from 'antd';
import Table from '@common/Table';
import RelativeDate, { FILTER_DATE_ENUM, getDate } from '@common/RelativeDate';

const {Option} = Select;
const PAGE_SIZE = 10;
const BANK_ACCOUNT = {
  '190623388': 'NĐC',
  '17013388': 'HVH',
  '49258047': 'ĐN - Online'
}
const BANK_ACCOUNT_LIST = Object.keys(BANK_ACCOUNT).map(x => ({
  value: x,
  name: BANK_ACCOUNT[x]
}))
const FILTER = {
  currentPage: 1,
  message: '',
  account: '',
  type: FILTER_DATE_ENUM.THISMONTH,
  timeRange: getDate(FILTER_DATE_ENUM.THISMONTH),
}

function BankTransfer(props) {
  const [data, setData] = useState([]);
  const [sumAmount, setSumAmount] = useState(0);
  const [filter, setFilter] = useState({...FILTER});
  const [total, setTotal] = useState(0);
  const ref = {};
  const handleLoadData = (filterData) => {
    const searchData = filterData ? {...filterData} : {...filter};
    const limit = PAGE_SIZE;
    const currentPage = searchData.currentPage ? searchData.currentPage : 1;
    const offset = (currentPage - 1) * PAGE_SIZE;
    const { from, to } = searchData.timeRange;
    let url = `limit=${limit}&offset=${offset}&from=${from}&to=${to}`;
    if(searchData.account !== ''){
      url += `&account=${searchData.account}`;
    }
    if(searchData.message !== ''){
      url += `&message=${searchData.message}`;
    }
    loadBankTransfer(url);
    if(props.user.role < 2) loadBankStat(url);
  }
  const { isLoading: loadingStat, mutate: loadBankStat } = useMutation((searchQuery = '') => {
    const url = `v1/bank-transfers/stat?${searchQuery}`;
    return request.get(url);
  },
    {
      onSuccess: (response) => {
        setSumAmount(response.data);
      },
    });
  const { isLoading, mutate: loadBankTransfer } = useMutation((searchQuery = '') => {
    // const searchData = filterData ? {...filterData} : {...filter};
    // const limit = PAGE_SIZE;
    // const currentPage = searchData.currentPage ? searchData.currentPage : 1;
    // const offset = (currentPage - 1) * PAGE_SIZE;
    // const { from, to } = searchData.timeRange;
    // let url = `v1/bank-transfers?limit=${limit}&offset=${offset}&from=${from}&to=${to}`;
    // if(searchData.account !== ''){
    //   url += `&account=${searchData.account}`;
    // }
    // if(searchData.message !== ''){
    //   url += `&message=${searchData.message}`;
    // }
    const url = `v1/bank-transfers?${searchQuery}`;
    return request.get(url);
  },
    {
      onSuccess: (response) => {
        const { count, rows } = response.data;
        rows.forEach(rec => {
          ref[rec.id] = null;
        })
        setData(rows);
        setTotal(count);
      },
    }
  )
  const onRef = (el, id) => {
    ref[id] = el;
  }
  const hanldeChangeFilter = (newFilter = {}, reload = true) => {
    const filterData = {...filter, ...newFilter};
    setFilter(filterData);
    if(reload) handleLoadData(filterData);
  }
  const onChangePage = (page) => {
    hanldeChangeFilter({currentPage: page})
  }
  const onChangeDate = (type, timeRange) => {
    setData([]);
    hanldeChangeFilter({currentPage: 1, type, timeRange})
  }
  const handleChangeSearch = e => {
    const { value, dataset } = e.target;
    const { field } = dataset;
    hanldeChangeFilter({[field]: value}, false)
  };
  const handleChangeAccount = value => {
    hanldeChangeFilter({account: value})
  };
  const handleDownload = async id => {
    const dataUrl = await htmlToImage.toJpeg(ref[id]);

    const link = document.createElement('a');
    link.download = `OTina-CK-${id}`;
    link.href = dataUrl;
    link.click();
    handleComplete(id);
  }
  const handleComplete = async id => {
    await request.put(`v1/bank-transfers/${id}`, { isDone: true });
    loadBankTransfer()
  }
  const handleDelete = async id => {
    await request.delete(`v1/bank-transfers/${id}`);
    loadBankTransfer()
  }
  const renderAccount = text => {
    if(BANK_ACCOUNT[text]) return `${BANK_ACCOUNT[text]} (${text})`;
    return text;
  }
  const columns = [
    {
      title: 'Ngày',
      dataIndex: 'createdAt',
      render: text => formatDateTime(text * 1000),
    },
    {
      title: 'Tài Khoản',
      dataIndex: 'account',
      render: renderAccount
    },
    {
      title: 'Số tiền',
      dataIndex: 'amount',
      align: 'right',
      render: formatNumber,
      sorter: (a, b) => a.total - b.total,
    },
    {
      title: 'Nội dung',
      dataIndex: 'message',
      render: (text, record) => (<>
        <div className="bankTransfer" >
          <div className='inner' ref={r => onRef(r, record.id)}>
            <p className='date'>{formatDateTime(record.createdAt * 1000)}</p>
            <p>
              Số tiền: <b>{formatNumber(record.amount)}</b> 
              {` - (${record.account})`}
            </p>
            <p>Nội dung{record.message}</p>
          </div>
        </div>
      </>
      )
    },
    {
      title: 'Tải hình',
      dataIndex: 'id',
      render: text => <Button icon="download" onClick={() => handleDownload(text)} />
    },
    {
      title: 'Đã xong',
      dataIndex: 'isDone',
      render: (_, record) => <Button disabled={record.isDone} onClick={() => handleComplete(record.id)}>{record.isDone ? 'Đã xong' : ' Xong'}</Button>
    },
  ]
  if(props.user.role < 2){
    columns.push({
      title: 'Xoá',
      render: (_, record) => <Button onClick={() => handleDelete(record.id)}>Xoá</Button>
    });
  }
  return (<>
    <Row gutter={16}>
      <Col sm={8}>
        <h2>Chuyển khoản <Button icon="redo" disabled={isLoading} onClick={() => handleLoadData()} /></h2>
      </Col>
      <Col sm={6}>
        {formatNumber(sumAmount)}
      </Col>
      <Col sm={10}>
        <RelativeDate type={FILTER_DATE_ENUM.THISMONTH} onChange={onChangeDate} />
      </Col>
    </Row>
    <Row gutter={16}>
      <Col sm={4}>
        <Select value={filter.account} onChange={handleChangeAccount} style={{width: '100%'}}>
          <Option value="">Chọn tài khoản</Option>
          {BANK_ACCOUNT_LIST.map(ba => (
            <Option value={ba.value}>{ba.name}</Option>
          ))}
        </Select>
      </Col>
      <Col sm={8}>
        <Input
            data-field="message"
            placeholder="Nội dung"
            value={filter.message}
            onChange={handleChangeSearch}
            onPressEnter={() => handleLoadData()}
          />
      </Col>
    </Row>
    <Row gutter={16} style={{ marginTop: '2rem' }}>
      <Col sm={24}>
        <Spin spinning={isLoading || loadingStat}>
          <Table
            className="bankTable"
            pagination={false}
            dataSource={data}
            columns={columns}
            rowKey="id" />
          <Pagination total={total} current={filter.currentPage} pageSize={PAGE_SIZE} onChange={onChangePage} />
        </Spin>
      </Col>
    </Row>
  </>)
}

BankTransfer.propTypes = {
};

BankTransfer.defaultProps = {
};

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
  userList: makeSelectUserList()
});

const mapDispatchToProps = dispatch => ({

});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(BankTransfer);
